import React from "react";
import TimestampConverter from "../../helpers/TimestampConverter.jsx";
import { convertTo24HourFormatback } from "../../services/timeFormat.js";

/**
 * TimeDisplay Component
 * Displays read-only time inputs (start and end time)
 */
const TimeDisplay = ({ startTime, endTime, timeFormat, onClick, className = "" }) => {
  const startTimeValue = timeFormat === 24
    ? convertTo24HourFormatback(TimestampConverter(startTime)) || ""
    : TimestampConverter(startTime) || "";

  const endTimeValue = timeFormat === 24
    ? convertTo24HourFormatback(TimestampConverter(endTime)) || ""
    : TimestampConverter(endTime) || "";

  return (
    <div className={`time-overview-sec ${className}`} onClick={onClick}>
      <input
        style={{ cursor: onClick ? "pointer" : "default" }}
        type="text"
        name="start_time"
        autoComplete="off"
        value={startTimeValue}
        className="time-show edit-time-start"
        readOnly
      />
      -
      <input
        style={{ cursor: onClick ? "pointer" : "default" }}
        type="text"
        name="end_time"
        autoComplete="off"
        value={endTimeValue}
        className="time-show edit-time-end"
        readOnly
      />
    </div>
  );
};

export default TimeDisplay;
